import { Observable, map } from "rxjs";
import { WebServicesService } from "../webservices.service";
import { SelectSearchData } from "src/app/shared/select-search/select-search.data";
import { ApiService } from "./_api.service";
import { Destination } from "src/app/_models/destination";
import { environment } from 'src/environments/environment';  // Importa environment per la base URL

export class DestinationApiService {
    constructor(private _ws: WebServicesService) {}

    // Destination methods
    get(): Observable<Destination[]> {
        const url = `${environment.wsBaseUrl}/api/Destination/all`;
        return this._ws.getWithCache(url, ApiService.CACHEKEY_DESTINATIONS);
    }

    getSelect(): Observable<SelectSearchData[]> {
        const url = `${environment.wsBaseUrl}/api/Destination/selectAll`;
        return this._ws.getWithCache(url, ApiService.CACHEKEY_DESTINATIONS_SELECT);
    }

    getList(ids: number[]): Observable<string> {
        const url = `${environment.wsBaseUrl}/api/Destination/list?${ids.map(id => `Id=${encodeURIComponent(id)}`).join('&')}`;
        return this._ws.getCsvContent(url);
    }

    getOne(id: number): Observable<Destination> {
        const url = `${environment.wsBaseUrl}/api/Destination/${encodeURIComponent(id)}`;
        return this._ws.getWithoutCache(url).pipe(
            map(des => {
                des.createdDateTime = new Date(des.createdDateTime);
                des.modifiedDateTime = new Date(des.modifiedDateTime);
                return des;
            })
        );
    }

    put(destination: Destination) {
        const url = `${environment.wsBaseUrl}/api/Destination/${encodeURIComponent(destination.id)}`;
        return this._ws.putJson(url, destination);
    }

    post(destination: Destination): Observable<Destination> {
        const url = `${environment.wsBaseUrl}/api/Destination/`;
        return this._ws.postJson(url, destination);
    }

    delete(destination: Destination) {
        const url = `${environment.wsBaseUrl}/api/Destination/${encodeURIComponent(destination.id)}`;
        return this._ws.deleteHttp(url);
    }
}
